'use client';

import { createContext, SetStateAction, useState, Dispatch, useContext, useEffect } from 'react';

import { Localization } from '@/types/localization';

type LocalizationContextType = {
  localization: Localization;
  setLocalization: Dispatch<SetStateAction<Localization>>;
};

export const LocalizationContext = createContext({} as LocalizationContextType);

export function LocalizationProvider({ children }) {
  const [localization, setLocalization] = useState({
    state: '',
    uf: '',
    city: ''
  });

  // https://nominatim.openstreetmap.org/reverse?lat=-31.7574627&lon=-52.3719937
  // https://nominatim.org/release-docs/develop/

  useEffect(() => {
    const storage = localStorage.getItem('@localization');

    if (storage) {
      setLocalization(JSON.parse(storage));
    }
  }, []);

  return (
    <LocalizationContext.Provider
      value={{
        localization,
        setLocalization
      }}
    >
      {children}
    </LocalizationContext.Provider>
  );
}

export const useLocationContext = () => {
  const context = useContext(LocalizationContext);

  if (!context) {
    throw new Error('useLocationContext must be used within an LocalizationProvider');
  }

  return context;
};
